/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ email: NonNullable<unknown> }} Common_Resend_Invite_DescriptionInputs */

const en_common_resend_invite_description = /** @type {(inputs: Common_Resend_Invite_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Resend the email invitation to ${i?.email}`)
};

/**
* | output |
* | --- |
* | "Resend the email invitation to {email}" |
*
* @param {Common_Resend_Invite_DescriptionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const common_resend_invite_description = /** @type {((inputs: Common_Resend_Invite_DescriptionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Resend_Invite_DescriptionInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_common_resend_invite_description(inputs)
});